import React from "react";
import { useNavigate } from "react-router-dom";
import PropTypes from 'prop-types';
import { Row, Col, Container } from 'react-bootstrap';
import { Card, SvgIcon } from "@mui/material";
import './InsurancePlanFooter.scss';

export default function InsurancePlanFooter({ InsurancePlan }) {
    const navigate = useNavigate();
    const navigateTo = (link) => {
        if (link) {
            navigate(link);
        }
    };
    return (
        <Container className="insurance-plan">
            <Row className='justify-content-center'><h3 className="mt-4">Complete your insurance plan</h3></Row>
            <Row className="plan-card">
                {InsurancePlan.map((item, index) => {
                    return (
                        <Col key={index} xs={12} md={4} lg={4} sm={12} className="mt-1 p-0">
                            <Card className="insurance-plan-card">
                                <Row className='ps-1'>
                                    <Col xs={2} sm={1} md={2} className='main-icon pt-1'>
                                        <SvgIcon component={item.icon} color='primary' viewBox='0 0 30 30' fontSize="large" />
                                    </Col>
                                    <Col xs={10} sm={11} md={10} className='main-content'>
                                        <span>{item.title}</span>
                                        <div className="plan-content">{item.content}</div>
                                        <button className={`insurance-btn mt-1 color-text`}
                                            onClick={() => navigateTo(item.linkTo)}>
                                            <b className="btn-name primary-color">{item.btnTitle}</b>
                                        </button>
                                    </Col>
                                </Row>
                            </Card>
                        </Col>
                    );
                })}
            </Row>
        </Container>
    );
};

InsurancePlanFooter.propTypes = {
    InsurancePlan: PropTypes.array,
};
